export default __webpack_public_path__ + "static/media/logo_black.c5b461c8.png";